import type { SVGProps } from 'react'
const SvgSyTechSolidContainers = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g fillRule="evenodd">
			<path
				fillOpacity={0.24}
				d="M6.67 3 2 5.76v12.48L6.67 21v-2.4L4 17.02V6.98L6.67 5.4zm2.66 6.14L12 10.71l2.67-1.57V5.98L12 4.41 9.33 5.98z"
			/>
			<path d="M9.33 5.98v3.16L12 10.71l2.67-1.57V5.98L12 7.56z" />
			<path d="m12 10.71 2.67-1.57V5.98L12 7.56z" />
			<path fillOpacity={0.24} d="m12.67 15.63 2.66 1.57L18 15.63v-3.16l-2.67-1.58-2.66 1.58z" />
			<path d="M12.67 12.47v3.16l2.66 1.57L18 15.63v-3.16l-2.67 1.58z" />
			<path d="M15.33 17.2 18 15.63v-3.16l-2.67 1.58z" />
			<path fillOpacity={0.24} d="m6 15.63 2.67 1.57 2.66-1.57v-3.16l-2.66-1.58L6 12.47z" />
			<path d="M6 12.47v3.16l2.67 1.57 2.66-1.57v-3.16l-2.66 1.58z" />
			<path d="m8.67 17.2 2.66-1.57v-3.16l-2.66 1.58zM2 8.17v7.67l2 1.18V6.98z" />
			<path d="m2 8.17 2-.46v-.73zm2 8.85v-.58l-2-.6z" />
			<path fillOpacity={0.24} d="M17.33 3v2.4L20 6.98v10.04l-2.67 1.58V21L22 18.24V5.76z" />
			<path d="m20 17.02 2-1.18V8.17l-2-1.19z" />
			<path d="m20 7.71 2 .46-2-1.19zm0 8.73v.58l2-1.18z" />
		</g>
	</svg>
)
export default SvgSyTechSolidContainers
